export const FEATURED_PROJECTS = [
  {
    id: "rose-garden",
    title: "Rose Garden XR",
    desc: "Unity, VR, Firebase, C#",
    thumb: "https://cdn.br-zhou.com/site-img/rose-thumb.jpg",
  },
  {
    id: "ubc-aero",
    title: "UBC AeroDesign",
    desc: "C, FreeRTOS, STM32",
    thumb: "https://cdn.br-zhou.com/site-img/aero-thumb.jpg",
  },
  {
    id: "candy-exterminator",
    title: "Candy Exterminator",
    desc: "C#, Unity",
    thumb: "https://cdn.br-zhou.com/site-img/candy-thumb.png",
  },
  {
    id: "csdc",
    title: "Canadian Satellite Design Challenge",
    desc: "C++, Arduino, PlatformIO",
    thumb:
    "https://cdn.br-zhou.com/site-img/csdc-thumb.jpg",
  },
  {
    id: "dino-brawl",
    title: "Dino Brawl",
    desc: "JavaScript, Socket.IO, React.js, Node.js",
    thumb:
      "https://cdn.br-zhou.com/site-img/dino-thumb.png",
  },
  {
    id: "ubc-rocket",
    title: "UBC Rocket Avionics",
    desc: "C++, FreeRTOS, MCUXpresso",
    thumb: "https://cdn.br-zhou.com/site-img/rocket-thumb.jpg",
  },
  {
    id: "react-path-finder",
    title: "A* Path Finder",
    desc: "Javascript, React, Redux, Tailwind.CSS",
    thumb: "https://cdn.br-zhou.com/site-img/path-thumb.jpg",
  },
  {
    id: "app-blocker",
    title: "Python App Blocker",
    desc: "Python, Command Line",
    thumb:
      "https://cdn.br-zhou.com/site-img/app-blocker-thumb.png",
  },
  {
    id: "chat-app",
    title: "Discord Clone",
    desc: "React.js, Node.js, Socket.io, MySQL, AWS",
    thumb: "https://cdn.br-zhou.com/site-img/disc-thumb.jpg",
  }
];

export const OTHER_PROJECTS = [
  {
    id: "site-tracker",
    title: "Site Usage Tracker",
    desc: "Javascript, Manifest V3",
  },
  {
    id: "personal-site",
    title: "Personal Website",
    desc: "React.js, Firebase, CSS",
  },
  {
    id: "flash-game",
    title: "Space Fighter",
    desc: "ActionScript 2, Adobe Flash",
  },
  {
    id: "unity-game",
    title: "3D Platformer",
    desc: "C#, Unity",
  },
  {
    id: "black-jack",
    title: "Black Jack",
    desc: "C++",
  },
  {
    id: "java-quiz-app",
    title: "Java Quiz App",
    desc: "Java, Swing Library",
  },
  {
    id: "physics-engine",
    title: "Custom Physics Engine",
    desc: "Javascript",
  },
  {
    id: "fitness-app",
    title: "Database Project",
    desc: "React.js, Oracle SQLPlus, Node.js, TailwindCSS",
  },
  {
    id: "fh-clubs",
    title: "High School Clubs Website",
    desc: "JQuery, Bootstrap, Javascript",
    // thumb:
    // "https://cdn.br-zhou.com/site-img/fh-clubs-thumb.png",
  },
  {
    id: "stretch-app",
    title: "Stretch App",
    desc: "React.js, Electron, Google OAuth, Hackathon",
  },
  {
    id: "ubc-clubs",
    title: "UBC Clubs",
    desc: "React.js, Python, SQL, AI, Hackathon",
  },
];

export const PROJECT_DETAILS = {
  "rose-garden": {
    title: "UBC Rose Garden XR",
    desc: "Worked in a group of 9 to develop an augmented reality experience that allows users to interact with the UBC rose garden during off-season. The experince is acompanied by a web app that allows users to send custom messages to visitors in the virtual garden. Person in thumbnail is Jason Kitikul.",
    img: [
      "https://cdn.br-zhou.com/site-img/rose-6.jpg",
      "https://cdn.br-zhou.com/site-img/rose-2.jpg",
      "https://cdn.br-zhou.com/site-img/rose-1.jpg",
      "https://cdn.br-zhou.com/site-img/rose-3.jpg",
      "https://cdn.br-zhou.com/site-img/rose-5.jpg",
      "https://cdn.br-zhou.com/site-img/rose-4.jpg",
    ],
  },
  "ubc-rocket": {
    title: "UBC Rocket Avionics",
    desc: "Collaborated with a team to develop and test aerospace-grade electronics. Successfully debugged mission-critical code, ensuring the reliability of electronic systems. Designed solutions for radio communications technology tailored for space missions. Actively contributed in bi-weekly team meetings, providing progress updates, sharing insights, and strategizing to achieve project milestones.",
    img: [
      "https://cdn.br-zhou.com/site-img/rocket-1.jpg",
      "https://cdn.br-zhou.com/site-img/rocket-2.jpg",
      "https://cdn.br-zhou.com/site-img/rocket-3.jpg",
    ],
  },
  "ubc-aero": {
    title: "UBC AeroDesign Avionics",
    desc: "Developed GPS and voltage sensing firmware for flight controller using C and FreeRTOS. Integrated sensor tasks with rest of flight controller logic using FreeRTOS. Revised flight controller PCB to fix schematic errors. Wrote Python scripts to communicate with flight controller using the Mavlink protocol.",
    img: [
      "https://cdn.br-zhou.com/site-img/aero-1.jpg",
      "https://cdn.br-zhou.com/site-img/aero-3.jpg",
      "https://cdn.br-zhou.com/site-img/aero-4.jpg",
      "https://cdn.br-zhou.com/site-img/aero-5.jpg",
      "https://cdn.br-zhou.com/site-img/aero-2.jpg",

    ],
  },
  "dino-brawl": {
    title: "Dino Brawl",
    desc: "Developed a online multiplayer proof of concept that integrates React.js with a custom game engine built from scratch. Used Socket.IO for live multiplayer.",
    img: [
      "https://cdn.br-zhou.com/site-img/dino-1.jpg",
      "https://cdn.br-zhou.com/site-img/dino-2.jpg",
      "https://cdn.br-zhou.com/site-img/dino-3.jpg",
    ],
    btn: {
      type: "disabled",
      text: "Sorry, no preview!",
    },
  },
  csdc: {
    title: "Canadian Satellite Design Challenge",
    desc: "Coordinated with teammates to design and implement the onboard state machine, enabling the satellite to accomplish multiple missions within a single launch. We were chosen to represent Canada in the International CanSat Competition, held by the European Space Agency.",
    img: [
      "https://cdn.br-zhou.com/site-img/csdc-1.jpg",
      "https://cdn.br-zhou.com/site-img/csdc-2.jpg",
      "https://cdn.br-zhou.com/site-img/csdc-3.jpg",
    ],
    btn: {
      link: "https://fhscienceacademy.com/posts/team_zephyr_cansat_competition_2022/",
      text: "See Article!",
    },
  },
  "candy-exterminator": {
    title: "Candy Exterminator",
    desc: "Designed and fully developed during the two-week-long 2021 $PLAY Game Jam, securing first place. Created an engaging gameplay experience with the objective of clearing levels by strategically eliminating evil gummy bears.",
    img: [
      "https://cdn.br-zhou.com/site-img/candy-1.png",
      "https://cdn.br-zhou.com/site-img/candy-2.jpg",
      "https://cdn.br-zhou.com/site-img/candy-3.jpg",
    ],

    btn: {
      link: "https://identitydeficiency.itch.io/the-candy-exterminator",
      text: "Play Online!",
    },
  },
  "react-path-finder": {
    title: "Grid-Based A* Path Finder",
    desc: "Fully built a grid-based path finding demo using React.js, Redux, Tailwind.CSS, and a custom 2d Rendering engine.",
    img: [
      "https://cdn.br-zhou.com/site-img/path-finder-1.jpg",
      "https://cdn.br-zhou.com/site-img/path-finder-2.jpg",
      "https://cdn.br-zhou.com/site-img/path-finder-3.jpg",
    ],

    btn: {
      link: "https://br-zhou.github.io/path-finder-react/",
      text: "Live Demo!",
    },
  },
  "app-blocker": {
    title: "Python App & Site Blocker",
    desc: "Leveraged Python, the Windows Command Line, and DNS overriding to develop a website and application blocker. Designed and integrated an intuitive graphical interface, ensuring easy application usage.",
    img: [
      "https://cdn.br-zhou.com/site-img/app-blocker-1.png",
      "https://cdn.br-zhou.com/site-img/app-blocker-2.png",
      "https://cdn.br-zhou.com/site-img/app-blocker-3.png",
    ],

    btn: {
      link: "https://www.youtube.com/watch?v=9tTuM99Hxrs&feature=youtu.be",
      text: "Watch Demo!",
    },
  },
  "fh-clubs": {
    title: "High School Clubs Website",
    desc: "Built for my grade 12 capstone. Participating in clubs played a significant role in shaping my high school experience. I created this website to provide new students with a platform to easily find and pursue their interests through club activities. Project was deployed and maintained for a few years by other Fraser Heights students.",
    img: [
      "https://cdn.br-zhou.com/site-img/fh-clubs-1.png",
      "https://cdn.br-zhou.com/site-img/fh-clubs-2.png",
      "https://cdn.br-zhou.com/site-img/fh-clubs-3.png",
      "https://cdn.br-zhou.com/site-img/fh-clubs-4.png",
    ],
    // btn: {
    //   link: "https://www.fhclubs.ca",
    // },
  },
  "personal-site": {
    title: "Personal Website",
    desc: "This very website. Yes, I added this entry to pad the project list. The image shows an early version of this website, which is viewable through the project's Git history.",
    img: [
      "https://cdn.br-zhou.com/site-img/website-1.png",
    ],
    btn: {
      link: "https://github.com/br-zhou/personal-website",
      text: "View Source Code!",
    },
  },
  "flash-game": {
    title: "Space Fighter",
    desc: "I developed from scratch using Adobe Flash when I was 12. I've lost most of the other games that I made during this period.",
    img: [
      "https://cdn.br-zhou.com/site-img/space-fighter-1.jpg",
      "https://cdn.br-zhou.com/site-img/space-fighter-2.jpg",
      "https://cdn.br-zhou.com/site-img/space-fighter-3.jpg",
    ],
  },
  "java-quiz-app": {
    title: "Java Quiz App",
    desc: "Built for CPSC 210 using Java and the Swing GUI library. This app helps students quiz themselves in preparation for tests. Users can create, edit, and take quizzes.",
    img: [
      "https://cdn.br-zhou.com/site-img/quiz-app-1.png",
      "https://cdn.br-zhou.com/site-img/quiz-app-2.png",
      "https://cdn.br-zhou.com/site-img/quiz-app-3.png",
    ],
    btn: {
      link: "https://github.com/br-zhou/Java-Quiz-Appication",
      text: "View Source Code!",
    },
  },
  "black-jack": {
    title: "Black Jack",
    desc: "Black Jack is a terminal game developed in C++. ",
    img: [
      "https://cdn.br-zhou.com/site-img/black-jack-1.png",
      "https://cdn.br-zhou.com/site-img/black-jack-2.png",
      "https://cdn.br-zhou.com/site-img/black-jack-3.png",
    ],
  },
  "physics-engine": {
    title: "Custom Physics & Game Engine",
    desc: "Designed and implemented a custom game engine library that handles collision detection, collision response, and rendering logic. The library's API is inspired by the UnityEnigine API, making it intuitive for game developers. Built for a web game I never deployed.",
  },
  "site-tracker": {
    title: "Site Usage Tracker",
    desc: "Tracks and displays browser usage. Syncs data across Google accounts. Created using Google's Manifest V3 API.",
    img: [
      "https://cdn.br-zhou.com/site-img/site-tracker-1.png",
    ],
  },
  "unity-game": {
    title: "3D Platformer",
    desc: "This is my first Unity game, which I built when I was 13. The game is a simple 3d platformer, where the objective is to collect coins and reach the end of the level. The game was built using the aid of online tutorials.",
    img: [
      "https://cdn.br-zhou.com/site-img/unity-game-1.png",
      "https://cdn.br-zhou.com/site-img/unity-game-2.png",
      "https://cdn.br-zhou.com/site-img/unity-game-3.png",
    ],
  },
  "chat-app": {
    title: "Real-Time Chat App",
    desc: "Developed a functional real-time chat application using React, Node.js, Express, and Socket.io. Strengthened application security by implementing password hashing and token-based authentication. Enabled persistent storage of credentials by leveraging MySQL. Successfully deployed the application using AWS’s S3, RDS, and EC2 services.",
    img: [
      "https://cdn.br-zhou.com/site-img/disc-1.jpg",
      "https://cdn.br-zhou.com/site-img/disc-2.jpg",
      "https://cdn.br-zhou.com/site-img/disc-3.jpg",
    ],
    btn: {
      type: "disabled",
      text: "Sorry, no preview!",
    },
  },
  "fitness-app": {
    title: "Fitness Database App",
    desc: "Built for CPSC 304. Led a team of three to create this online fitness app. Planned project timeline, discussed and carried out implementation, and conducted weekly group meetings to ensure project's success.",
    img: [
      "https://cdn.br-zhou.com/site-img/fitness-app-1.jpg",
      "https://cdn.br-zhou.com/site-img/fitness-app-2.jpg",
      "https://cdn.br-zhou.com/site-img/fitness-app-3.jpg",
      "https://cdn.br-zhou.com/site-img/fitness-app-4.jpg",
      "https://cdn.br-zhou.com/site-img/fitness-app-5.jpg",
    ],
    btn: {
      link: "https://github.com/br-zhou/exercise-db-app",
      text: "View Source Code!",
    },
  },
  "stretch-app": {
    title: "Stretch Reminder App",
    desc: "Created a desktop application using React.js and Electron that reminds users to stretch at regular intervals. Implemented Google OAuth to disable notifications during company meetings. Built in 24 hours for company hackathon. Used Google Gemini for UI design.",
    img: [
      "https://cdn.br-zhou.com/site-img/stretch-1.jpg",
      "https://cdn.br-zhou.com/site-img/stretch-2.jpg",
      "https://cdn.br-zhou.com/site-img/stretch-3.jpg",
      "https://cdn.br-zhou.com/site-img/stretch-4.jpg",
    ],
  },
  "ubc-clubs": {
    title: "UBC Clubs Agent",
    desc: "Created a database of all UBC clubs by scraping UBC's official club directory. Allow users to easily search and give reviews for existing clubs. Integrated Gemini as assistant with club information context. Built in 24 hours for nwHacks 2026. GUI generated by Google Gemini.",
    img: [
      "https://cdn.br-zhou.com/site-img/ubc-clubs-1.jpg",
      "https://cdn.br-zhou.com/site-img/ubc-clubs-2.jpg",
      "https://cdn.br-zhou.com/site-img/ubc-clubs-3.jpg",
      "https://cdn.br-zhou.com/site-img/ubc-clubs-4.jpg",
      "https://cdn.br-zhou.com/site-img/ubc-clubs-5.jpg",
    ],
  },
  "untitled-game": {
    title: "MOBA Game",
    desc: "Currently developing a multiplayer browser game inspired by League of Legends and Brawl Stars. Client is built using TypeScript, Three.js, and React.",
    img: [
      "https://cdn.br-zhou.com/site-img/untitled-game-1.jpg",
      "https://cdn.br-zhou.com/site-img/untitled-game-2.jpg",
      "https://cdn.br-zhou.com/site-img/untitled-game-3.jpg",
    ],
    btn: {
      type: "disabled",
      text: "Coming Soon!",
    },
  },
};
